module.exports = __webpack_public_path__ + "img/blog.c71d34e9.svg";